import { gql } from "@apollo/client";
import SPECIAL_FRAGMENT from "@/fragments/special";

const GET_SPECIALS_LIST = gql`
    ${SPECIAL_FRAGMENT}
    query GetSpecialsList( $retailerId: ID! ) {
        specials( retailerId: $retailerId ) {
            ...specialFragment
        }
    }
`;
export default GET_SPECIALS_LIST;